import { render } from "./NavbarSection.vue?vue&type=template&id=15b54798"
import script from "./NavbarSection.vue?vue&type=script&lang=js"
export * from "./NavbarSection.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__